import { SellerListing } from './sellerListingsCollectionReducer';

export function hasInsightRecommendation(listing: SellerListing): boolean {
  const insight = listing.featuredListingInsight;
  return !!(insight?.featuredWinner || insight?.eligibleForTopSpot || listing.lowVisibility);
}
